import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useCompany } from '../../hooks/SuperAdmin/useCompany'

import AddCompany from './AddCompany'

export default function EditCompany() {
  const { company, getCompany } = useCompany()
  const params = useParams()
  console.log({ PARAMS: params.companyId })
  useEffect(() => {
    getCompany({ companyId: params.companyId })
  }, [params.companyId])

  return <> {company ? <AddCompany company={company} /> : <Loader />} </>
}
